import { OrganizationReportActiveUsersDailyEntity } from '../entities/';
import { authResource } from './Auth';
import { schema } from '@data-client/rest';
export const OrganizationReportActiveUsersDailyResource = authResource({
    path: '/organizations/:organizationId/reports/activeusersdaily/:activeUsersDailyId?',
    searchParams: {},
    schema: OrganizationReportActiveUsersDailyEntity
}).extend('getList', {
    schema: {
        counts: new schema.Collection([OrganizationReportActiveUsersDailyEntity]),
        items: new schema.Collection([OrganizationReportActiveUsersDailyEntity])
    }
});
